//IE11のapiキャッシュを対策するために事前にinterceptorsを設定したaxios
import axios from 'axios';
import { CSRFToken } from '../../util/mixin/csrfToken.mixin';

axios.interceptors.request.use(function (config) {
  config.headers = {
    'X-CSRF-TOKEN': CSRFToken.computed._csrf(),
    'X-Requested-With': 'XMLHttpRequest',
    Pragma: 'no-cache'
  };
  return config;
});

export default axios;
